// extracted by mini-css-extract-plugin
module.exports = {"navigationLogo":"topNavigation-module--navigationLogo--3wruJ"};